var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var gql = String.raw;
export var PermissionsFields = gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  id name slug \n  permissionTypes { id name slug } \n  grantedPerson { \n    id name slug \n    organisation { id name } \n    photo { id url } \n    location { id name slug state { id name abbr } openGraph { id image { id url } } \n    country { id name slug shorthand } } \n  }\n"], ["\n  id name slug \n  permissionTypes { id name slug } \n  grantedPerson { \n    id name slug \n    organisation { id name } \n    photo { id url } \n    location { id name slug state { id name abbr } openGraph { id image { id url } } \n    country { id name slug shorthand } } \n  }\n"])));
var templateObject_1;